// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"2ff6bf44","346":"9936dbdc","515":"7af04133","815":"2fd43f6b","917":"ac97d7df","951":"d73d0e1e"}[chunkId] + ".chunk.css";
};